export default {
    name: 'FormInput',

    props: {
        value: {
            default: '',
        },
        rules: {
            type: [String, Object],
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        helper: {
            type: String,
            default: '',
        },
        vid: {
            type: String,
            default: undefined,
        },
        type: {
            type: String,
            default: 'text',
        },
        label: {
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        icon: {
            default: false,
        },
        disable_spacebar: {
            default: false,
        },
        disable_keys: {
            default: () => [],
        },
    },

    data: () => ({
        currentValue: '',
    }),

    created() {
        this.currentValue = this.value;
    },

    watch: {
        currentValue(val) {
            this.$emit('input', val);
        },

        value(val) {
            this.currentValue = val;
        },
    },
};
